import { ApplicationState } from 'application/redux';
import { connect } from 'react-redux';
import { addSelectedFilters, updateInput } from '../../multiple-search/redux/action';
import InputComponent from './input-component';

const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
  t: state.i18n.t
});

export default connect(mapStateToProps, { addSelectedFilters, updateInput })(InputComponent);
